import { Stack, Typography, Button, useTheme } from "@mui/material";

import { Strings } from "@app/constants";

interface CategoryCardProps {
  title: string;
  description: string;
  image: string;
  buttonText?: string;
  onClick?: () => void;
}

const CategoryCard = ({
  title,
  description,
  image,
  buttonText,
  onClick,
}: CategoryCardProps) => {
  const theme = useTheme();

  return (
    <Stack
      alignItems="center"
      sx={{
        backgroundColor: theme.palette.common.white,
        borderRadius: "14px",
        width: "100%",
        maxWidth: { xs: 320, sm: 340, md: 350 },
        minHeight: { xs: 330, md: 345 },
        px: { xs: 2, sm: 2.25 },
        pt: { xs: 1.75, sm: 2 },
        pb: { xs: 2, sm: 2.25 },
        justifyContent: "space-between",
        textAlign: "center",
        boxShadow: "0 10px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Stack alignItems="center">
        <img
          src={image}
          alt={title}
          style={{
            width: "100%",
            maxWidth: 230,
            height: 130,
            objectFit: "contain",
          }}
          loading="lazy"
        />
        <Typography
          variant="h5"
          sx={{
            color: theme.palette.common.black,
            fontFamily: "Work Sans",
            fontSize: { xs: 17, sm: 18 },
            fontWeight: 800,
            lineHeight: 1.12,
            mt: 1.5,
            minHeight: 40,
            width: "100%",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "rgba(0, 0, 0, 0.68)",
            fontFamily: "Work Sans",
            fontSize: { xs: 12, sm: 13 },
            fontWeight: 500,
            lineHeight: 1.25,
            mt: 1,
            maxWidth: 275,
          }}
        >
          {description}
        </Typography>
      </Stack>

      <Stack alignItems="center" sx={{ mt: 2 }}>
        <Button
          sx={{
            borderRadius: "999px",
            textTransform: "none",
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            fontFamily: "Work Sans",
            fontSize: 12,
            fontWeight: 700,
            minWidth: 118,
            minHeight: 36,
            px: 2.5,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
              boxShadow: "none",
            },
          }}
          onClick={onClick}
        >
          {buttonText ?? Strings.button.checkProducts}
        </Button>
      </Stack>
    </Stack>
  );
};

export { CategoryCard };
